
import { Component, Vue } from 'vue-property-decorator'
import TimeTable from './components/TimeTable.vue'

@Component({
  components: {
    TimeTable,
  },
})
export default class App extends Vue {}
